import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
}
export function CTAButton({
  text = 'QUIERO ORDENAR MI ESTUDIO HOY',
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://checkout.abastecedordigital.shop/cart/51749378916672:1" className={`inline-flex items-center justify-center gap-2 md:gap-3 bg-gold text-[#0a1628] font-bold text-base md:text-xl py-3 md:py-4 px-6 md:px-8 rounded-lg shadow-[0_0_20px_rgba(201,168,76,0.4)] hover:shadow-[0_0_30px_rgba(201,168,76,0.6)] transition-shadow duration-300 ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} data-id="element-30">
      <ShoppingCartIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-31" />
      <span className="text-center" data-id="element-32">{text}</span>
    </motion.a>;
}